import { ALLOWED_EXTENSIONS, ALLOWED_MIME_TYPES } from './const';

export const getFileExtension = (name: string): string => {
  const parts = name.split('.');
  return parts.length > 1 ? parts[parts.length - 1].toLowerCase() : '';
};

export const isAllowedFile = (file: File): boolean => {
  const hasValidExtension = ALLOWED_EXTENSIONS.includes(getFileExtension(file.name));
  const hasValidMimeType = ALLOWED_MIME_TYPES.includes(file.type.toLowerCase());

  return hasValidExtension || hasValidMimeType;
};
